var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNovoUsuarios(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.16673 17.2718C3.64377 17.4163 4.2881 17.4163 5.38337 17.4163H13.6167C14.712 17.4163 15.3563 17.4163 15.8334 17.2718M3.16673 17.2718C3.06444 17.2408 2.96985 17.2032 2.88015 17.1575C2.43326 16.9298 2.06993 16.5665 1.84223 16.1196C1.58337 15.6115 1.58337 14.9465 1.58337 13.6163V5.38301C1.58337 4.05288 1.58337 3.38782 1.84223 2.87978C2.06993 2.4329 2.43326 2.06957 2.88015 1.84187C3.38819 1.58301 4.05325 1.58301 5.38337 1.58301H13.6167C14.9468 1.58301 15.6119 1.58301 16.1199 1.84187C16.5668 2.06957 16.9301 2.4329 17.1578 2.87978C17.4167 3.38782 17.4167 4.05288 17.4167 5.38301V13.6163C17.4167 14.9465 17.4167 15.6115 17.1578 16.1196C16.9301 16.5665 16.5668 16.9298 16.1199 17.1575C16.0302 17.2032 15.9356 17.2408 15.8334 17.2718M3.16673 17.2718C3.16699 16.6311 3.17083 16.2921 3.22755 16.0069C3.47743 14.7507 4.4594 13.7687 5.71559 13.5189C6.02148 13.458 6.38934 13.458 7.12504 13.458H11.875C12.6107 13.458 12.9786 13.458 13.2845 13.5189C14.5407 13.7687 15.5227 14.7507 15.7725 16.0069C15.8293 16.2921 15.8331 16.6311 15.8334 17.2718M12.6667 7.52051C12.6667 9.26941 11.2489 10.6872 9.50004 10.6872C7.75114 10.6872 6.33337 9.26941 6.33337 7.52051C6.33337 5.77161 7.75114 4.35384 9.50004 4.35384C11.2489 4.35384 12.6667 5.77161 12.6667 7.52051Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNovoUsuarios);
export default __webpack_public_path__ + "static/media/NovoUsuarios.e5540aec16844c0bf6755bbc4a492e87.svg";
export { ForwardRef as ReactComponent };